/**
 * Circular timer
 * */
bookingApp.directive('skTimer',function(){
    return {
        scope: {progress: '@'},
        link: function(scope, element, attrs){
            attrs.$observe('progress', function(value) {
                var angle, speed = attrs.speed;
                value = Math.floor(parseFloat(value));
                if(value<25){
                    angle = -90 + (value/100)*360;
                    element.find(".animate-0-25-b").css("transform","rotate("+angle+"deg)");
                    element.find('.animate-25-50-b,.animate-50-75-b,.animate-75-100-b').css('transform', 'rotate(90deg)');
                }
                else if(value>=25 && value<50){
                    angle = -90 + ((value-25)/100)*360;
                    element.find(".animate-0-25-b").css("transform","rotate(0deg)");
                    element.find(".animate-25-50-b").css("transform","rotate("+angle+"deg)");
                    element.find('.animate-50-75-b,.animate-75-100-b').css('transform', 'rotate(90deg)');
                }
                else if(value>=50 && value<75){
                    angle = -90 + ((value-50)/100)*360;
                    element.find(".animate-25-50-b, .animate-0-25-b").css("transform","rotate(0deg)");
                    element.find(".animate-50-75-b").css("transform","rotate("+angle+"deg)");
                    element.find('.animate-75-100-b').css('transform', 'rotate(90deg)');
                }
                else if(value>=75 && value<=100){
                    angle = -90 + ((value-75)/100)*360;
                    element.find(".animate-50-75-b, .animate-25-50-b, .animate-0-25-b")
                        .css("transform","rotate(0deg)");
                    element.find(".animate-75-100-b").css("transform","rotate("+angle+"deg)");
                }
            });
        },
        template:
            '<div class="timer"> ' +
                '<div class="timer-bg"></div>' +
                '<div class="spinner-holder-one animate-0-25-a">' +
                    '<div class="spinner-holder-two animate-0-25-b">' +
                        '<div class="timer-spinner"></div>' +
                    '</div>' +
                '</div>' +
                '<div class="spinner-holder-one animate-25-50-a">' +
                    '<div class="spinner-holder-two animate-25-50-b">' +
                        '<div class="timer-spinner"></div>' +
                    '</div>' +
                '</div>' +
                '<div class="spinner-holder-one animate-50-75-a">' +
                    '<div class="spinner-holder-two animate-50-75-b">' +
                        '<div class="timer-spinner"></div>' +
                    '</div>' +
                '</div>' +
                '<div class="spinner-holder-one animate-75-100-a">' +
                    '<div class="spinner-holder-two animate-75-100-b">' +
                        '<div class="timer-spinner"></div>' +
                    '</div>' +
                '</div>' +
            '</div>'
    };
});